module.exports = __webpack_public_path__ + "static/media/hospital.4de09ec2.png";